/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
		GENERAL - iframe Resizer
		========================================================================== */

const iframeResizerInit = function () {
  window.addEventListener("message", function (event) {
    var frames = document.getElementsByTagName("iframe");

    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === event.source) {
        jQuery(frames[i]).height(event.data);
        break;
      }
    }
  });
};

iframeResizerInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function (el) {
      const acc_item = item.closest(".accordion__item");
      acc_item.classList.toggle("accordion__item--open");
      // $(el.target).addClass("active");
      const panelOuter = $(acc_item).find(".accordion__answer .inner")[0];
      const panel = $(acc_item).find(".accordion__answer")[0];
      // this.classList.toggle("active");
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panelOuter.scrollHeight + "px";
      }
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Expand Blog
  ========================================================================== */
const expandBlogInit = function () {
  const blog__categories = document.querySelector(".pageheader--blog .pageheader__header");
  const blog__categories__height = document.querySelector(".pageheader__categories-inner");
  const pageheader__categories = document.querySelector(".pageheader__categories");

  if (blog__categories) {
    blog__categories.addEventListener("click", function (e) {
      var dropdown_height = blog__categories__height.offsetHeight;
      blog__categories.classList.toggle("active");
      // Make dropdown show and set classes to say it's open
      if (blog__categories.classList.contains("active")) {
        pageheader__categories.style.height = dropdown_height + "px";
      } else {
        pageheader__categories.style.height = "0px";
      }
    });

    window.addEventListener("resize", function (event) {
      var dropdown_height = blog__categories__height.offsetHeight;
      if (blog__categories.classList.contains("active")) {
        pageheader__categories.style.height = dropdown_height + "px";
      }
    });
  }
}; // expandBlogInit();
expandBlogInit();

/*  ==========================================================================
    GENERAL - Expand Jobs
  ========================================================================== */
const expandJobsInit = function () {
  const blog__categories = document.querySelector(".jobs .header");
  const blog__categories__height = document.querySelector(".job__categories-inner");
  const pageheader__categories = document.querySelector(".job__categories");

  if (blog__categories) {
    blog__categories.addEventListener("click", function (e) {
      var dropdown_height = blog__categories__height.offsetHeight;
      blog__categories.classList.toggle("active");
      // Make dropdown show and set classes to say it's open
      if (blog__categories.classList.contains("active")) {
        pageheader__categories.style.height = dropdown_height + "px";
      } else {
        pageheader__categories.style.height = "0px";
      }
    });

    window.addEventListener("resize", function (event) {
      var dropdown_height = blog__categories__height.offsetHeight;
      if (blog__categories.classList.contains("active")) {
        pageheader__categories.style.height = dropdown_height + "px";
      }
    });
  }
}; // expandBlogInit();
expandJobsInit();

/*  ==========================================================================
    GENERAL - Expand Careers
  ========================================================================== */
const expandCareersInit = function () {
  const blog__categories = document.querySelector(".jobs .header");
  const blog__categories__height = document.querySelector(".pageheader__categories-inner");
  const pageheader__categories = document.querySelector(".pageheader__categories");

  if (blog__categories) {
    blog__categories.addEventListener("click", function (e) {
      var dropdown_height = blog__categories__height.offsetHeight;
      blog__categories.classList.toggle("active");
      // Make dropdown show and set classes to say it's open
      if (blog__categories.classList.contains("active")) {
        pageheader__categories.style.height = dropdown_height + "px";
      } else {
        pageheader__categories.style.height = "0px";
      }
    });

    window.addEventListener("resize", function (event) {
      var dropdown_height = blog__categories__height.offsetHeight;
      if (blog__categories.classList.contains("active")) {
        pageheader__categories.style.height = dropdown_height + "px";
      }
    });
  }
}; // expandCareersInit();
expandCareersInit();

/*  ==========================================================================
    GENERAL - Grow Image on scroll
  ========================================================================== */

const grownImagesInit = function () {
  const grownImages = document.querySelectorAll(".images--grow .mediaimg__img");

  if (grownImages.length > 0) {
    grownImages.forEach(function (e) {
      function getPercentage() {
        const parentElement = e.closest(".images--grow");
        const rect = parentElement.getBoundingClientRect();

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const topRelativeToDocument = rect.top + scrollTop;

        const bottomRelativeToDocument = topRelativeToDocument + rect.height;

        const scrollTop2 = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight2 = window.innerHeight || document.documentElement.clientHeight;
        const bottomOfScreen2 = scrollTop2 + windowHeight2;

        const calcPercentage =
          ((bottomOfScreen2 - topRelativeToDocument) / (bottomRelativeToDocument - topRelativeToDocument)) * 100;
        const perfect = 100 - calcPercentage;
        if (perfect < 100) {
          const grow_percentage = perfect / 4;
          $(parentElement)
            .find(".mediaimg")
            .css({
              "clip-path": "inset(0 " + grow_percentage + "% 0 " + grow_percentage + "%)"
            });
        }
      }
      getPercentage();
      window.addEventListener("wheel", function () {
        getPercentage();
      });
      window.addEventListener("resize", function () {
        getPercentage();
      });
    });
  }
};

if (!isMobile) {
  grownImagesInit();
}

/*  ==========================================================================
    GENERAL - Grow Image on scroll
  ========================================================================== */

const parallaxColumns = function () {
  const grownImages = document.querySelectorAll(".float--up");
  const grownImages2 = document.querySelectorAll(".float--down");

  if (grownImages.length > 0) {
    let windowWidth3 = window.innerWidth;
    grownImages.forEach(function (e, index) {
      function getPercentage() {
        const divElement = e.closest(".col");
        const moduleMain = e.closest(".module--featured--content-grid");
        const rect = divElement.getBoundingClientRect();

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const topRelativeToDocument = rect.top + scrollTop;

        const bottomRelativeToDocument = topRelativeToDocument + rect.height;

        const scrollTop2 = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight2 = window.innerHeight || document.documentElement.clientHeight;
        const bottomOfScreen2 = scrollTop2 + windowHeight2;

        const calcPercentage =
          ((bottomOfScreen2 - topRelativeToDocument) / (bottomRelativeToDocument - topRelativeToDocument)) * 100;
        const perfect = 100 - calcPercentage;
        // if (perfect < 100) {

        if (windowWidth3 > 1000 && windowWidth3 < 1400) {
          const grow_percentage = perfect / 6;
          $(".float--up").css({
            top: grow_percentage + "px"
          });
        } else if (windowWidth3 > 1000 && windowWidth3 < 1200) {
          const grow_percentage = perfect / 4;
          $(".float--up").css({
            top: grow_percentage + "px"
          });
        } else if (windowWidth3 > 1000 && windowWidth3 > 1400) {
          const grow_percentage = perfect / 4;
          $(".float--up").css({
            top: grow_percentage + "px"
          });
        } else {
          $(".float--up").css({
            top: "0px"
          });
        }

        // }
        if (perfect < 100) {
          moduleMain.style.overflow = "visible";
        } else {
          moduleMain.style.overflow = "hidden";
        }
      }
      getPercentage();
      window.addEventListener("wheel", function () {
        getPercentage();
      });
      window.addEventListener("resize", function () {
        getPercentage();
      });
      window.addEventListener("load", function () {
        getPercentage();
      });
    });
  }

  if (grownImages2.length > 0) {
    let windowWidth3 = window.innerWidth;
    grownImages2.forEach(function (e, index) {
      function getPercentage() {
        const divElement = e.closest(".col");
        const moduleMain = e.closest(".module--featured--content-grid");
        const rect = divElement.getBoundingClientRect();

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const topRelativeToDocument = rect.top + scrollTop;

        const bottomRelativeToDocument = topRelativeToDocument + rect.height;

        const scrollTop2 = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight2 = window.innerHeight || document.documentElement.clientHeight;
        const bottomOfScreen2 = scrollTop2 + windowHeight2;

        const calcPercentage =
          ((bottomOfScreen2 - topRelativeToDocument) / (bottomRelativeToDocument - topRelativeToDocument)) * 100;
        const perfect = 100 - calcPercentage;

        // if (perfect < 100) {
        if (windowWidth3 > 1000 && windowWidth3 < 1400) {
          const grow_percentage = perfect / 3;
          $(".float--down").css({
            bottom: grow_percentage + "px"
          });
        } else if (windowWidth3 > 1000 && windowWidth3 < 1200) {
          const grow_percentage = perfect / 7;
          $(".float--down").css({
            bottom: grow_percentage + "px"
          });
        } else if (windowWidth3 > 1000 && windowWidth3 > 1400) {
          const grow_percentage = perfect / 2;
          $(".float--down").css({
            bottom: grow_percentage + "px"
          });
        } else {
          $(".float--down").css({
            bottom: "0px"
          });
        }
        // }
        if (perfect < 100) {
          moduleMain.style.overflow = "visible";
        } else {
          moduleMain.style.overflow = "hidden";
        }
      }
      getPercentage();
      window.addEventListener("wheel", function () {
        getPercentage();
      });
      window.addEventListener("resize", function () {
        getPercentage();
      });
      window.addEventListener("load", function () {
        getPercentage();
      });
    });
  }
};

if (!isMobile) {
  parallaxColumns();
}
/*  ==========================================================================
    GENERAL - Stacked Items
  ========================================================================== */

const siteheader = document.querySelector(".siteheader");
const stackedItems = document.querySelector(".stacked-items");
const stackedItemsBtn = document.querySelector(".stacked-items .btn");
const stackmedia__overlay = document.querySelector(".stackmedia__overlay");
const imgCarouselClose = document.querySelector(".image-carousel__close");
let desktopBreakpoint2 = 1200;
let windowWidth2 = window.innerWidth;
let windowHeight2 = window.innerHeight;

if (stackedItemsBtn) {
  if (windowWidth2 > desktopBreakpoint2) {
    const stackedmedia = document.querySelector(".stackmedia");

    var parallaxInstance = new Parallax(stackedmedia, {
      relativeInput: true,
      inputElement: $(this).closest(".module--stacked-items").get(0),
      hoverOnly: true
    });
  }

  // Event listener for the reset button
  stackedItemsBtn.addEventListener("click", function (e) {
    e.preventDefault();

    if (parallaxInstance) {
      parallaxInstance.disable();
    }

    $(".stackparallax").css({ transform: "translate3d(0, 0, 0)" });
    setTimeout(() => {
      $(".stackparallax").children().unwrap();
      $(".stackparallax__inner").children().unwrap();
    }, 250);
    setTimeout(() => {
      stackedItems.classList.add("active");
      stackmedia__overlay.classList.add("active");
      if (windowWidth2 > desktopBreakpoint2) {
        let cardGridWrapper2 = document.querySelector(".stackmedia");
        CardGridInstance = new CardGridMoves({
          el: cardGridWrapper2,
          ease: 0.02
        });
        CardGridInstance.bindEvents();
        CardGridInstance.tick();
      }
      document.body.classList.add("noscroll");
      $(".stackparallax").css({ transform: "scale(1)" });
    }, 300);
  });

  imgCarouselClose.addEventListener("click", function () {
    if (windowWidth2 > desktopBreakpoint2) {
      setTimeout(() => {
        stackmedia__overlay.classList.remove("active");
        if (parallaxInstance) {
          parallaxInstance.enable();
        }
        $(".stackmedia").children().wrap("<div class='stackparallax'></div>");
        $(".stackparallax").children().wrap("<div class='stackparallax__inner'></div>");
      }, 1000);
    } else {
      stackmedia__overlay.classList.remove("active");
      $(".stackmedia").children().wrap("<div class='stackparallax'></div>");
      $(".stackparallax").children().wrap("<div class='stackparallax__inner'></div>");
    }

    stackedItems.classList.remove("active");
    document.body.classList.remove("noscroll");
    if (windowWidth2 > desktopBreakpoint2) {
      let cardGridWrapper2 = document.querySelector(".stackmedia");

      CardGridInstance = new CardGridMoves({
        el: cardGridWrapper2,
        ease: 0.02
      });
      CardGridInstance.bindEvents();
      CardGridInstance.tick();
    }
  });
}

window.addEventListener("resize", function () {
  let windowWidth2 = window.innerWidth;
  const stackedmedia2 = document.querySelectorAll(".stacked-items__media");
  stackedmedia2.forEach(function (el) {
    let parallaxInstance2 = el._parallaxInstance;
    if (windowWidth2 > desktopBreakpoint2) {
      if (!parallaxInstance2) {
        parallaxInstance2 = new Parallax(el, {
          relativeInput: true,
          inputElement: $(el).closest(".module--audience-panel")[0],
          hoverOnly: true
        });
        el._parallaxInstance = parallaxInstance2;
      }
    } else {
      if (parallaxInstance2) {
        parallaxInstance2.disable();
        parallaxInstance2.destroy();
        el._parallaxInstance = null;
      }
    }
  });
});

window.addEventListener("load", function () {
  const stackedmedia2 = document.querySelectorAll(".stacked-items__media");
  stackedmedia2.forEach(function (el) {
    let parallaxInstance2 = el._parallaxInstance;
    if (windowWidth2 > desktopBreakpoint2) {
      if (!parallaxInstance2) {
        parallaxInstance2 = new Parallax(el, {
          relativeInput: true,
          inputElement: $(el).closest(".module--audience-panel")[0],
          hoverOnly: true
        });
        el._parallaxInstance = parallaxInstance2;
      }
    } else {
      if (parallaxInstance2) {
        parallaxInstance2.destroy();
        el._parallaxInstance = null;
      }
    }
  });
});

/*  ==========================================================================
    GENERAL - Apply owl items with custom navigations
  ========================================================================== */

const prevNavigation = document.querySelector(".navigation__previous");
const nextNavigation = document.querySelector(".navigation__next");
if (nextNavigation) {
  const currentParent = $(prevNavigation).parent().parent().parent().parent().find(".owl-carousel");

  $(prevNavigation).on("click", function () {
    currentParent.trigger("prev.owl.carousel");
  });

  $(nextNavigation).on("click", function () {
    currentParent.trigger("next.owl.carousel");
  });

  currentParent.on("changed.owl.carousel", function (e) {
    if (e.item.index - 1 < 1) {
      $(".current__index").text("01");
    } else {
      const index__count = e.item.index - 1 < 10 ? `0${e.item.index - 1}` : e.item.index;
      $(".current__index").text(index__count);
    }
  });
}

const customOwlNavigations = document.querySelectorAll(".module--featured-capabilities, .module--quote-post");
if (customOwlNavigations.length > 0) {
  $(customOwlNavigations).each(function (e) {
    const currentParent = $(this);
    const currentCarousel = currentParent.find(".owl-carousel");
    const innerLinks = $(currentParent).find(".navigation__item");
    $(innerLinks).each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        const slideLocation = $(this).attr("data-slide");
        currentCarousel.trigger("to.owl.carousel", slideLocation - 1);
        $(currentParent).find("a").removeClass("active");
        $(this).addClass("active");
      });
    });
  });
}

const loaderDuration = 10000; // 10 seconds

const onloaderContainer = document.querySelectorAll(".module--carousel-feature");

if (onloaderContainer.length > 0) {
  $(onloaderContainer).each(function () {
    const currentParent = $(this);
    const currentCarousel = currentParent.find(".owl-carousel");
    const innerLinks = $(currentParent).find(".navigation__item");
    const onLoader = $(this).find(".owl-loader");

    $(innerLinks).each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          const slideLocation = $(this).attr("data-slide");

          currentCarousel.trigger("refresh.owl.carousel");
          currentCarousel.trigger("to.owl.carousel", slideLocation - 1);
          $(currentParent).find("a").removeClass("active");
          $(this).addClass("active");
          onLoader.find(".owl-loader-inner").stop();
          currentCarousel.trigger("stop.owl.autoplay");
          currentCarousel.trigger("play.owl.autoplay", [loaderDuration]);
          lazyLoadInstance.update();
        }
      });
    });

    // Start the loader when mouse has hovered
    this.addEventListener(
      "mouseover",
      function () {
        const onLoader = $(this).find(".owl-loader");
        const currentCarousel = $(this).find(".owl-carousel");
        currentCarousel.trigger("play.owl.autoplay", [loaderDuration]);
        onLoader.find(".owl-loader-inner").animate({ width: "100%" }, loaderDuration).animate({ width: "0" }, 0);
        currentCarousel.on("changed.owl.carousel", function (event) {
          onLoader.find(".content__inner").hide();
          onLoader.find(".owl-loader-inner").animate({ width: "100%" }, loaderDuration).animate({ width: "0" }, 0);
          const currentIndex = event.item.index - 2 < 10 ? `0${event.item.index - 2}` : event.item.index - 2;
          $(innerLinks).each(function () {
            $(this).removeClass("active");
          });
          $(".navigation__item[data-slide='" + currentIndex + "']").addClass("active");
        });
      },
      { once: true }
    );
  });
}

/*  ==========================================================================
    GENERAL - Pinned Scroll
  ========================================================================== */

const pinnedScrollInit = function () {
  const grownImages = document.querySelectorAll(".pinned-scroll__wrapper");

  if (grownImages.length > 0) {
    window.addEventListener("wheel", function (event) {
      let ww = window.innerWidth;

      grownImages.forEach(function (e) {
        // Pinned scroll position
        const pinnedScrollElement = e.closest(".module--pinned-scroll");
        const pinnedScrollPosition = pinnedScrollElement.getBoundingClientRect();

        // Spacer positioning
        const currentSpacer = e;
        const spacerPosition = currentSpacer.getBoundingClientRect();
        const scrollTopSpacer = window.pageYOffset || document.documentElement.scrollTop;
        const spacerRelativeToDocument = spacerPosition.top + scrollTopSpacer;

        // Place all spacers into an array for later access
        const spacerDifference = [];
        const countContent = e.querySelectorAll(".spacer");

        countContent.forEach(element => {
          const rect = element.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const topRelativeToDocument = rect.top + scrollTop;
          const difference = topRelativeToDocument - spacerRelativeToDocument;
          spacerDifference.push(difference * 1.25);
        });

        // Handle vertical progress bar
        const windowHeight2 = window.innerHeight || document.documentElement.clientHeight;

        let currentValuex = pinnedScrollPosition.top;
        let minValuex = 0;
        let maxValuex = pinnedScrollPosition.height - windowHeight2;

        let percentagex = ((currentValuex - minValuex) / (maxValuex - minValuex)) * 100;
        const percentagex2 = Math.abs(percentagex);

        if (percentagex < 0) {
          $(".pinned-scroll__progress-inner").css({
            width: `${percentagex2}%`
          });
        } else {
          $(".pinned-scroll__progress-inner").css({
            width: `0`
          });
        }

        // If we have started the pinned process
        if (pinnedScrollPosition.top < 0) {
          const countContent2 = e.querySelectorAll(".scroll__content-inner");

          let someIndex = 0;
          countContent2.forEach(element => {
            currentValuex = Math.abs(pinnedScrollPosition.top);
            if (someIndex === 0) {
              minValuex = 0;
              maxValuex = spacerDifference[0];
            } else {
              minValuex = spacerDifference[someIndex - 1];
              maxValuex = spacerDifference[someIndex];
            }
            percentagex = ((currentValuex - minValuex) / (maxValuex - minValuex)) * 100;
            const countContent22 = e.querySelectorAll(".scroll__content-inner")[someIndex + 1];
            $(countContent22)
              .find(".mediaimg")
              .css({
                clipPath: `inset(${100 - percentagex}% 0 0 0)`
              });
            if (percentagex > 100) {
              const countContentAllContent = e.querySelectorAll(".scroll__content-inner");
              if (someIndex + 1 < countContentAllContent.length) {
                countContentAllContent.forEach((currrentContent, index) => {
                  if (index === someIndex + 1) {
                    if (!$(currrentContent).hasClass("active")) {
                      $(currrentContent).addClass("active");
                    }
                  } else {
                    $(currrentContent).removeClass("active");
                  }
                });
              }
            } else {
              if (someIndex === 0) {
                const countContentAllContent = e.querySelectorAll(".scroll__content-inner");
                countContentAllContent.forEach((currrentContent, index) => {
                  if (index === someIndex) {
                    if (!$(currrentContent).hasClass("active")) {
                      $(currrentContent).addClass("active");
                    }
                  } else {
                    $(currrentContent).removeClass("active");
                  }
                });
              }
            }
            someIndex++;
          });
        } else {
          const countContentAll = e.querySelectorAll(".scroll__content-inner")[1];
          $(countContentAll).find(".mediaimg").css({
            clipPath: `inset(100% 0 0 0)`
          });
        }
      });
    });
  }
};

if (!isMobile) {
  pinnedScrollInit();
}

const numberedListInit = function () {
  const numberedLists = document.querySelectorAll(".module--numbered-list");

  if (numberedLists.length > 0) {
    numberedLists.forEach(function (e) {
      $(".navigation__item").click(function (e) {
        $(".navigation__item").removeClass("active");
        if (!$(this).hasClass("active")) {
          $(this).addClass("active");
        }
      });
    });

    $(".numbered-list__content .content__item").each(function () {
      var $el = $(this);
      const numberedIndex = $el.attr("data-count");

      $el.waypoint({
        handler: function (direction) {
          if (direction === "down") {
            $el.closest(".module--numbered-list").find(`.navigation__item`).removeClass("active");
            $el.closest(".module--numbered-list").find(`.navigation__item-${numberedIndex}`).addClass("active");
          } else {
            $el.closest(".module--numbered-list").find(`.navigation__item`).removeClass("active");
            $el.closest(".module--numbered-list").find(`.navigation__item-${numberedIndex}`).addClass("active");
          }
        },
        offset: "50%"
      });
    });
  }
};

numberedListInit();

/*  ==========================================================================
	General - Download Popup
	========================================================================== */
// downloadPopupInit() helper function
function downloadFile(url, fileName) {
  fetch(url, { method: "get", mode: "no-cors", referrerPolicy: "no-referrer" })
    .then(res => res.blob())
    .then(res => {
      const aElement = document.createElement("a");
      aElement.setAttribute("download", fileName);
      const href = URL.createObjectURL(res);
      aElement.href = href;
      aElement.setAttribute("target", "_blank");
      aElement.click();
      URL.revokeObjectURL(href);
    });
}
// downloadPopupInit() helper function end

function downloadPopupInit() {
  const groupNavLinks = document.querySelectorAll(
    ".tile--download, .pageheader--market .pageheader__cta, .pageheader--product .pageheader__cta, .papertype__info"
  );
  const bodyClick = document.querySelector("body");
  const downloadpopup__close = document.querySelector("#downloadpopup__close");

  const groupnavOpenclass = "downloadpopupopen";
  const downloadTitle = document.querySelector(".downloadpopup__heading-content");
  let downloadLink = "";

  if (downloadpopup__close) {
    downloadpopup__close.addEventListener("click", function (e) {
      body.classList.remove(groupnavOpenclass);
      var gwrf = window.gwrf_3;
      if (typeof gwrf !== "undefined") {
        gwrf.reloadForm();
      }
    });

    bodyClick.addEventListener("click", function (e) {
      if (e.target.classList.contains("downloadpopup__container")) {
        if (!body.classList.contains(groupnavOpenclass)) {
          body.classList.add(groupnavOpenclass);
        } else {
          body.classList.remove(groupnavOpenclass);
          var gwrf = window.gwrf_3;
          if (typeof gwrf !== "undefined") {
            gwrf.reloadForm();
          }
        }
      }
    });

    $(document).on("gform_confirmation_loaded", function (e, form_id) {
      if (form_id === 3) {
        downloadFile(downloadLink, `${downloadTitle.innerHTML}`);
      }
    });
    $(document).on("gform_post_render", function (e, form_id) {
      if (form_id === 3) {
        // Remove existing click event listeners to prevent duplicates
        groupNavLinks.forEach(function (groupLink) {
          $(groupLink).off("click"); // This ensures any previous click handlers are removed

          // Now re-attach the click event listener
          $(groupLink).on("click", function (ed) {
            const downloadcampaign = document.querySelector("#input_3_6");
            const checkRestriction = ed.target.closest("a.download__link");
            if (checkRestriction) {
              downloadLink = checkRestriction.href;
              downloadTitle.innerHTML = checkRestriction.dataset.name;
              $(downloadcampaign).val(checkRestriction.dataset.name);
              if (checkRestriction.classList.contains("restrict")) {
                ed.preventDefault();
                if (!body.classList.contains(groupnavOpenclass)) {
                  body.classList.add(groupnavOpenclass); // Open the popup
                } else {
                  body.classList.remove(groupnavOpenclass); // Close the popup
                }
              }
            }
          });
        });
      }
    });
  }
}

downloadPopupInit();

/*  ==========================================================================
	General - Video Popup
	========================================================================== */

function videoPopupInit() {
  const bodyClick = document.querySelector("body");
  const downloadpopup__close = document.querySelector("#videopopup__close");
  const groupnavOpenclass = "videopopupopen";

  const videoLink = document.querySelectorAll(".watch");
  videoLink.forEach(function (video) {
    video.addEventListener("click", function (e) {
      e.preventDefault();
      if (!body.classList.contains(groupnavOpenclass)) {
        // IT'S NOT OPEN...
        // mobnavSetHeight();
        body.classList.add(groupnavOpenclass);
      } else {
        // IT'S OPEN...
        body.classList.remove(groupnavOpenclass);
      }

      downloadpopup__close.addEventListener("click", function (e) {
        e.preventDefault();
        body.classList.remove(groupnavOpenclass);
      });

      // bodyClick.addEventListener("click", function (e) {
      //   e.preventDefault();

      //   if (e.target.classList.contains("videopopup__container")) {
      //     if (!body.classList.contains(groupnavOpenclass)) {
      //       body.classList.add(groupnavOpenclass);
      //     } else {
      //       body.classList.remove(groupnavOpenclass);
      //     }
      //   }
      // });
    });
  });
}

videoPopupInit();

/*  ==========================================================================
	General - Copy Link Functionality
	========================================================================== */
function copyLinkInit() {
  const getCopyLink = document.querySelector(".copyLink");
  if (getCopyLink) {
    getCopyLink.addEventListener("click", function (e) {
      e.preventDefault();
      navigator.clipboard.writeText(window.location.href);
      document.querySelector(".copyLink").innerHTML = "Url Copied...";
      $(getCopyLink).delay(1000).fadeOut();
      setTimeout(() => {
        document.querySelector(".copyLink").innerHTML = "Copy Link";
        $(getCopyLink).delay(500).fadeIn();
      }, 1350);
    });
  }
}

copyLinkInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const filterTags = document.querySelectorAll(".filter-tag");

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".posts.loadmore-container");
const downloadContainer = document.querySelector(".downloads.loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);
    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page,
        cats: php_variables.current_cat,
        tags: php_variables.tags
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      currentPage.searchParams.set("tags", php_variables.tags);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page,
    tags: php_variables.tags,
    cats: php_variables.current_cat
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

function returnActiveTags() {
  let activeArray = [];
  let activeString = "";
  filterTags.forEach(element => {
    if (element.classList.contains("active")) {
      activeArray.push(element.dataset.slug);
      activeString += `${element.dataset.slug},`;
    }
  });
  return {
    active_array: activeArray,
    active_string: activeArray.join(",")
  };
}

function setActiveTags(clickedElement) {
  if (clickedElement.target.dataset.slug === "all") {
    filterTags.forEach(element => {
      if (element.dataset.slug !== "all") {
        element.classList.remove("active");
      } else {
        element.classList.add("active");
      }
    });
  } else {
    clickedElement.target.classList.toggle("active");
    filterTags.forEach(element => {
      if (element.dataset.slug === "all") {
        element.classList.remove("active");
      }
    });
    const activeTags = returnActiveTags();
    const countActiveTags = activeTags.active_array.length;
    if (countActiveTags === 0) {
      filterTags.forEach(element => {
        if (element.dataset.slug === "all") {
          element.classList.add("active");
        }
      });
    }
  }
}

const loadFilterInit = function () {
  filterTags.forEach(element => {
    element.addEventListener("click", function (tag) {
      const button = loadmoreBtn;
      php_variables.currentPage = 1;

      const currentPage = new URL(window.location);
      setActiveTags(tag);
      const activeTags = returnActiveTags();

      // Tags t pass to our post request
      php_variables.tags = activeTags.active_string;

      // Populate data to send
      const data = {
        action: "filter",
        cats: php_variables.current_cat,
        page: php_variables.current_page,
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        tags: activeTags.active_string // that's how we get params from wp_localize_script() function
      };

      // This AJAX triggers a PHP hook within functions-ajax.php called ajax_filter_handler
      $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          var responseData = JSON.parse(data);
          var htmlMarkup = responseData.html;
          var httmlcount = responseData.count;
          if (htmlMarkup) {
            // Once markup is returned, we need to update the html markup
            php_variables.max_page = httmlcount;
            php_variables.current_page = 1;

            // button.textContent = buttonText; // set back to previous button text
            loadmoreContainer.innerHTML = htmlMarkup; // insert new posts to the loadmore-container, this should be the row that includes the posts

            // Only push state to set the last page number or if there is more pages to load
            const currentPage = new URL(window.location);

            if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
              currentPage.searchParams.set("tags", php_variables.tags);
              currentPage.searchParams.set("pagenum", php_variables.current_page);
              history.pushState({}, "", currentPage);
            }

            //Updating the loadmore link
            const nextPage = new URL(window.location);
            nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);
            nextPage.searchParams.set("tags", php_variables.tags);

            if (button) {
              button.href = nextPage;
            }

            // if last page, remove the button..
            if (button) {
              if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
                button.style.display = "none";
              } else {
                button.style.display = "block";
              }
            }

            // Re-init links to make sure linklines on newly loaded content still work
            linksInit();
            // Re-init lazy load
            lazyLoadInstance.update(); // reinit lazy load after clones
          } else {
            button.style.display = "none"; // if no data, remove the button as well
          }
        }
      });
    });
  });
};

if (filterTags && loadmoreContainer) {
  loadFilterInit();
}

const downloadsFilterInit = function () {
  const getMarketFilter = document.querySelector("#filter__market");
  const getProductFilter = document.querySelector("#filter__product");
  const filterSearch = document.querySelector("#filter__search");
  const downloadCount = document.querySelector(".download__header-count span");
  const downloadsWrap = document.querySelector(".downloads__row");

  function checkNoResults() {
    if (downloadCount.innerText === 0) {
      downloadsWrap.classList.add("no__results");
    } else {
      downloadsWrap.classList.remove("no__results");
    }
  }

  // start isotope shuffle
  var grid = $(".downloads__row").isotope({
    itemSelector: ".col",
    layoutMode: "fitRows",
    fitRows: {
      equalheight: true
    }
  });
  var iso = grid.data("isotope");

  // Check the tags first
  const initTags = returnActiveTags();

  let initFilter = "";
  initTags.active_array.forEach(filterElement => {
    initFilter += `.${filterElement}, `;
  });

  initFilter = initFilter.substring(0, initFilter.length - 2);

  // If there are tags assigned, filter
  if (initFilter !== ".all") {
    grid.isotope({ filter: `${initFilter}` });
    downloadCount.innerText = iso.filteredItems.length;
  }

  // foreach tag, loop through and attatch a click event
  filterTags.forEach(element => {
    element.addEventListener("click", function (tag) {
      // get active tags
      filterSearch.value = "";
      getMarketFilter.value = "all";
      getProductFilter.value = "all";
      var elems = grid.isotope("getFilteredItemElements");
      // iso.reloadItems();
      setActiveTags(tag);
      const activeTags = returnActiveTags();

      let populateFilter = "";
      activeTags.active_array.forEach(filterElement => {
        if (getMarketFilter.value !== "all") {
          populateFilter += `.${getMarketFilter.value}`;
        }
        if (getProductFilter.value !== "all") {
          populateFilter += `.${getProductFilter.value}`;
        }
        populateFilter += `.${filterElement}, `;
      });

      populateFilter = populateFilter.substring(0, populateFilter.length - 2);
      if (activeTags.active_array.includes("all")) {
        if (getProductFilter.value !== "all") {
          grid.isotope({ filter: `${populateFilter.replace(".all", "")}` });
        } else if (getMarketFilter.value !== "all") {
          grid.isotope({ filter: `${populateFilter.replace(".all", "")}` });
        } else {
          grid.isotope({ filter: `*` });
        }
      } else {
        grid.isotope({ filter: `${populateFilter}` });
      }
      elems.forEach(elementss => {
        // grid.isotope("revealItemElements", elems);
        $(elementss).show();
      });
      downloadCount.innerText = iso.filteredItems.length;
      filterSearch.value = "";

      const currentPage = new URL(window.location);
      currentPage.searchParams.set("tags", activeTags.active_string);
      history.pushState({}, "", currentPage);

      checkNoResults();
    });
  });

  filterSearch.addEventListener("keyup", function (search) {
    const getValue = search.target.value;
    var elems = grid.isotope("getFilteredItemElements");
    let num = 0;
    elems.forEach(elementss => {
      if (!$(elementss).text().match(getValue)) {
        $(elementss).hide();
      } else {
        num++;
        $(elementss).show();
      }
    });
    downloadCount.innerText = num;
    grid.isotope();

    checkNoResults();
  });

  getMarketFilter.addEventListener("change", function (selectFilter) {
    const activeTags = returnActiveTags();

    let populateFilter = "";
    activeTags.active_array.forEach(filterElement => {
      if (selectFilter.target.value !== "all") {
        populateFilter += `.${selectFilter.target.value}`;
      }
      if (getProductFilter.value !== "all") {
        populateFilter += `.${getProductFilter.value}`;
      }
      populateFilter += `.${filterElement}, `;
    });

    populateFilter = populateFilter.substring(0, populateFilter.length - 2);
    if (activeTags.active_array.includes("all")) {
      if (selectFilter.target.value !== "all") {
        grid.isotope({ filter: `${populateFilter.replace(".all", "")}` });
      } else if (getProductFilter.value !== "all") {
        grid.isotope({ filter: `${populateFilter.replace(".all", "")}` });
      } else {
        grid.isotope({ filter: `*` });
      }
    } else {
      grid.isotope({ filter: `${populateFilter}` });
    }
    downloadCount.innerText = iso.filteredItems.length;
    checkNoResults();
  });

  getProductFilter.addEventListener("change", function (selectFilter) {
    const activeTags = returnActiveTags();

    let populateFilter = "";
    activeTags.active_array.forEach(filterElement => {
      if (selectFilter.target.value !== "all") {
        populateFilter += `.${selectFilter.target.value}`;
      }
      if (getMarketFilter.value !== "all") {
        populateFilter += `.${getMarketFilter.value}`;
      }
      populateFilter += `.${filterElement}, `;
    });

    populateFilter = populateFilter.substring(0, populateFilter.length - 2);
    if (activeTags.active_array.includes("all")) {
      if (selectFilter.target.value !== "all") {
        grid.isotope({ filter: `${populateFilter.replace(".all", "")}` });
      } else if (getMarketFilter.value !== "all") {
        grid.isotope({ filter: `${populateFilter.replace(".all", "")}` });
      } else {
        grid.isotope({ filter: `*` });
      }
    } else {
      grid.isotope({ filter: `${populateFilter}` });
    }
    downloadCount.innerText = iso.filteredItems.length;
    checkNoResults();
  });
};

if (filterTags && downloadContainer) {
  downloadsFilterInit();
}

const careersContainer = document.querySelector(".jobs__container");

const careersFilterInit = function () {
  // start isotope shuffle
  var grid = $(".jobs__container").isotope({
    itemSelector: ".jobs__wrapper",
    layoutMode: "fitRows",
    fitRows: {
      equalheight: true
    }
  });
  var iso = grid.data("isotope");

  // Check the tags first
  const initTags = returnActiveTags();

  let initFilter = "";
  initTags.active_array.forEach(filterElement => {
    initFilter += `.${filterElement}, `;
  });

  initFilter = initFilter.substring(0, initFilter.length - 2);

  // If there are tags assigned, filter
  if (initFilter !== ".all") {
    grid.isotope({ filter: `${initFilter}` });
  }

  // foreach tag, loop through and attatch a click event
  filterTags.forEach(element => {
    element.addEventListener("click", function (tag) {
      // get active tags
      var elems = grid.isotope("getFilteredItemElements");
      // iso.reloadItems();
      setActiveTags(tag);
      const activeTags = returnActiveTags();
      let populateFilter = "";
      activeTags.active_array.forEach(filterElement => {
        populateFilter += `.${filterElement}, `;
      });

      populateFilter = populateFilter.substring(0, populateFilter.length - 2);

      if (activeTags.active_array.includes("all")) {
        grid.isotope({ filter: `*` });
      } else {
        grid.isotope({ filter: `${populateFilter}` });
      }

      const currentPage = new URL(window.location);
      currentPage.searchParams.set("tags", activeTags.active_string);
      history.pushState({}, "", currentPage);
    });
  });
};

if (filterTags && careersContainer) {
  careersFilterInit();
}

/*  ==========================================================================
  Text animations
  ========================================================================== */

// Text Reveal (slide up)

if ($(".text-reveal").length > 0) {
  textreveal__init();
}

function textreveal__init() {
  setTimeout(function () {
    $(".text-reveal.heading_line_1")
      .not(".text-reveal--ready")
      .each(function () {
        if ($(this).hasClass("text-reveal--chars")) {
          $(this).lettering("words");
          $(this).find("span").lettering();
        } else {
          $(this).lettering("words");
          $(this).find("span").lettering("words");
        }
        var $el = $(this);
        $el.waypoint({
          handler: function (direction) {
            if (direction === "down") {
              $el.addClass("text-reveal--ready");
            } else {
              $el.removeClass("text-reveal--ready");
            }
          },
          offset: "95%"
        });
      });
  }, 0);
  setTimeout(function () {
    $(".text-reveal.heading_line_2")
      .not(".text-reveal--ready")
      .each(function () {
        if ($(this).hasClass("text-reveal--chars")) {
          $(this).lettering("words");
          $(this).find("span").lettering();
        } else {
          $(this).lettering("words");
          $(this).find("span").lettering("words");
        }
        var $el = $(this);
        $el.waypoint({
          handler: function (direction) {
            if (direction === "down") {
              $el.addClass("text-reveal--ready");
            } else {
              $el.removeClass("text-reveal--ready");
            }
          },
          offset: "95%"
        });
      });
  }, 150);
  setTimeout(function () {
    $(".text-reveal.heading_line_3__inner")
      .not(".text-reveal--ready")
      .each(function () {
        if ($(this).hasClass("text-reveal--chars")) {
          $(this).lettering("words");
          $(this).find("span").lettering();
        } else {
          $(this).lettering("words");
          $(this).find("span").lettering("words");
        }
        var $el = $(this);
        $el.waypoint({
          handler: function (direction) {
            if (direction === "down") {
              $el.addClass("text-reveal--ready");
            } else {
              $el.removeClass("text-reveal--ready");
            }
          },
          offset: "95%"
        });
      });
  }, 300);
}

// Text Fade
if ($(".text-fade").length > 0) {
  textfade__init();
}

function textfade__init() {
  $(".text-fade")
    .not(".text-fade--ready")
    .each(function () {
      $(this).lettering();
      var $el = $(this);
      $el.waypoint({
        handler: function (direction) {
          if (direction === "down") {
            $el.addClass("text-fade--ready");
          } else {
            $el.removeClass("text-fade--ready");
          }
        },
        offset: "100%"
      });
    });
}

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const mobilecenter = elem.dataset.mobilecenter ? elem.dataset.mobilecenter : false;
    const responsiveArray = carouselResponsiveArray(elem, mobilecenter);

    // Optional data attribute settings
    const fadeIn = elem.dataset.animate && elem.dataset.animate === "default" ? false : "fadeIn";
    const fadeOut = elem.dataset.animate && elem.dataset.animate === "default" ? false : "fadeOut";
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplaytimeout ? elem.dataset.autoplaytimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const mouseDrag = elem.dataset.mousedrag && elem.dataset.mousedrag === "disable" ? false : true;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      animateIn: fadeIn, // add this
      animateOut: fadeOut, // and this
      // animateIn: animate,
      mouseDrag: mouseDrag,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", `<i class='far fa-arrow-right'></i>`],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function (e) {
        lazyLoadInstance.update();
        Waypoint.refreshAll();

        $(elem)
          .find(".owl-nav")
          .append(
            `<span class="owl-nav__count"><span class="owl-nav__current">01</span> <span>/</span> <span class="owl-nav__total">0${e.item.count}</span></span>`
          );
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });

    $(elem).on("changed.owl.carousel", function (e) {
      $(".owl-nav__current").html(`0${e.item.index + 1}`);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem, mobilecenter) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems,
        center: mobilecenter && classWidth < 1000 ? true : false
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */
/* jshint ignore:start */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const topnavBd = document.querySelector(".topnav__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";
const groupnavOpenclass = "groupnavopen";
const siteheaderWrap = document.querySelector(".siteheader__wrap");

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height * 1.5;
  mobnav.style.height = `${mobnavHeight}px`;
  mobnav.style.opacity = 1;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...

      const mobileSlides = document.querySelectorAll(".sitenav--mobile");
      const menuid_all = document.querySelector("#menuid_all");
      const logolink = document.querySelector(".siteheader__logo__img");

      logolink.dataset.menuid = "";
      // mobnav.style.right = "-100vw";
      mobnav.style.opacity = 0;

      body.classList.remove(mobnavOpenclass);

      mobileSlides.forEach(function (subLink) {
        subLink.style.right = "-100vw";
      });

      menuid_all.style.right = "0";
      menuid_all.style.opacity = "1";
      mobnav.style.height = 0;
      if (logolink.classList.contains("active")) {
        logolink.style.opacity = 0;

        setTimeout(() => {
          logolink.classList.remove("active");
          logolink.style.opacity = 1;
        }, 150);
      }
      logolink.removeAttribute("data-menuid");
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
  // mobnavSetHeight();
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
    const logolink = document.querySelector(".siteheader__logo__img");
    if (body.classList.contains(mobnavOpenclass)) {
      if (window.innerWidth > gridSizes.xl) {
        mobnav.style.opacity = 0;
        logolink.classList.remove("active");
      } else {
        logolink.classList.add("active");
      }
    }
  },
  true
);

/*  ==========================================================================
	NAVIGATION - Groupnav
	========================================================================== */

function groupNavInit() {
  const groupNavLinks = document.querySelectorAll("#groupnav__close, #groupnav__open");
  const bodyClick = document.querySelector("body");

  groupNavLinks.forEach(function (groupLink) {
    groupLink.addEventListener("click", function (e) {
      e.preventDefault();
      if (!body.classList.contains(groupnavOpenclass)) {
        // IT'S NOT OPEN...
        // mobnavSetHeight();
        body.classList.add(groupnavOpenclass);
      } else {
        // IT'S OPEN...
        body.classList.remove(groupnavOpenclass);
      }
    });
  });

  bodyClick.addEventListener("click", function (e) {
    if (e.target.classList.contains("groupnav__container")) {
      if (!body.classList.contains(groupnavOpenclass)) {
        // IT'S NOT OPEN...
        // mobnavSetHeight();
        body.classList.add(groupnavOpenclass);
      } else {
        // IT'S OPEN...
        body.classList.remove(groupnavOpenclass);
      }
    }
  });
}

groupNavInit();

/*  ==========================================================================
	NAVIGATION - Mobile Nav Components
	========================================================================== */

function mobileNavComponentsInit() {
  const links = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown");
  const mobileSlides = document.querySelectorAll(".sitenav--mobile");

  const logolink = document.querySelector(".siteheader__logo__img");
  const defaultSlide = document.querySelector(`#menuid_all`);

  // Clicking on logo
  logolink.addEventListener("click", function (e) {
    // If the mobile nav is not active, or on desktop
    if (e.target.classList.contains("active")) {
      e.preventDefault();

      // Get the id of the menu froom the logo
      const getSelectedID = e.target.dataset.menuid;

      // Then loop through the navigation slides
      mobileSlides.forEach(function (subLink) {
        const getFirstSelectedID = getSelectedID.split("_");

        // If there is an id in the slide
        if (subLink.id == "menuid_" + getFirstSelectedID[0]) {
          // And we are on the first slide
          if (getFirstSelectedID.length == 1) {
            // Hide all other slides and replace back to menu logo
            subLink.style.right = "-100vw";
            logolink.dataset.menuid = getFirstSelectedID[0];
            logolink.style.opacity = 0;
            logolink.removeAttribute("data-menuid");

            // Then show the logo
            setTimeout(() => {
              logolink.classList.remove("active");
              logolink.style.opacity = 1;
            }, 150);

            // Then show the first slide
          } else {
            subLink.style.right = "0";
            logolink.dataset.menuid = getFirstSelectedID[0];
          }
        } else {
          const getSelectedID_secondary = subLink.id;
          const getFirstSelectedID22 = getSelectedID_secondary.split("_");
          const getLocation = getFirstSelectedID22.length - 1;
          if (getLocation == 1 && getFirstSelectedID.length == 2) {
            subLink.style.right = "100vw";
            subLink.style.opacity = "0";
          } else if (getLocation == 2 && getFirstSelectedID.length == 2) {
            subLink.style.right = "-100vw";
            if (subLink.classList.contains(`menuid_${getSelectedID}`)) {
              setTimeout(() => {
                subLink.style.opacity = "0";
              }, 1000);
            } else {
            }
          } else if (getLocation == 1 && getFirstSelectedID.length == 1) {
            subLink.style.right = "-100vw";
          } else {
            subLink.style.right = "-100vw";
            defaultSlide.style.right = "0";
            defaultSlide.style.opacity = "1";
          }
        }
      });
    }
  });

  links.forEach(function (link) {
    link.addEventListener("click", function (e) {
      const check = e.target.closest("li");
      const siteheader__logo__img = document.querySelector(`.siteheader__logo__img`);
      const logo2 =
        typeof siteheader__logo__img.dataset.menuid !== "undefined"
          ? siteheader__logo__img.dataset.menuid.split("_").length
          : 0;
      if (check.classList.contains("sitenav__item--hasdropdown")) {
        e.preventDefault();
        const getElement = check.dataset.menuid;
        const currentSlide = document.querySelector(`#menuid_${getElement}`);
        const menuid_all = document.querySelector("#menuid_all");

        mobileSlides.forEach(function (subLink) {
          const getSelectedID2 = subLink.id;
          const getFirstSelectedID2 = getSelectedID2.split("_");
          const getLocation = getFirstSelectedID2.length - 1;

          if (siteheader__logo__img.dataset.menuid !== "undefined") {
            const ccc = document.querySelector(`#menuid_${siteheader__logo__img.dataset.menuid}`);
            if (ccc) {
              ccc.style.opacity = "1";
            } else {
              subLink.style.opacity = "0";
            }
          }

          if (subLink.classList.contains(`menuid_${getElement}`)) {
            if (logo2 != 0) {
              menuid_all.style.opacity = "0";
            } else {
              menuid_all.style.opacity = "1";
            }
          }
          if (logo2 == 0 && getLocation == 1) {
            subLink.style.right = `100vw`;
          } else if (logo2 == 0 && getLocation == 2) {
            subLink.style.right = `-100vw`;
          } else if (logo2 == 1 && getLocation == 1) {
            subLink.style.right = `100vw`;
          } else {
            subLink.style.right = `200vw`;
          }
        });

        siteheader__logo__img.setAttribute("data-menuid", getElement);

        if (!siteheader__logo__img.classList.contains("active")) {
          siteheader__logo__img.style.opacity = 0;
          setTimeout(() => {
            siteheader__logo__img.classList.add("active");
            siteheader__logo__img.style.opacity = 1;
          }, 150);
        }

        currentSlide.style.opacity = "1";
        currentSlide.style.right = "0";
      }
    });
  });
}

mobileNavComponentsInit();

/*  ==========================================================================
			NAVIGATION - sitenav dropdowns
			========================================================================== */

const sitenav = document.querySelector(".sitenav--desktop");
const sitenavitems = sitenav.querySelectorAll("li[data-dropdownsection]");
const sitenavdropdown = document.querySelector(".sitenav__dropdown");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "dropdownsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;

// Check if isMobile, and only init if desktop or Ipad
if (!isMobile) {
  sitenav__init();
}

function sitenav__init() {
  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    if (sitenavitems) {
      sitenavitems.on("tap click hover", function (e) {
        e.preventDefault();
        if (this.classList.contains(overclass)) {
          navopen = false;
          sitenav__close();
        } else {
          dropdownsection__open(this);
        }
      });
    }
  } else {
    // IF DESKTOP...
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("mouseover", e => {
        sitenavitem__over(sitenavitem);
      });
      sitenavitem.addEventListener("mouseout", e => {
        sitenav__out();
      });
    });
    sitenavdropdown.addEventListener("mouseover", e => {
      dropdownsection__over();
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      sitenav__out();
    });
  }
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  // On hover of sitenav item
  dropdownsection__open(sitenavitem);
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".dropdownsection--" + target_li.dataset.dropdownsection);
  var dropdown_height = target_section.offsetHeight;
  const activesectionclass = "dropdownsection--active";

  // Make dropdown show and set classes to say it's open
  sitenavdropdown.style.height = dropdown_height + "px";
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to stop dropdown closing
    window.clearTimeout(dropdownclosetimer);
  }
  //$("." + overclass, sitenav).removeClass(overclass);
  target_li.classList.add(overclass);
  document.querySelector("body").classList.add(navopenbodyclass);
  if (document.querySelector("." + activesectionclass)) {
    document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
  }
  target_section.classList.add(activesectionclass);
} //dropdownsection__open();

function dropdownsection__over() {
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out() {
  // On leave sitenav hover
  navopen = false;
  // Start timeout to close sitenav dropdown
  dropdownclosetimer = window.setTimeout(sitenav__close, 250);
} // sitenavitem__over()

function sitenav__close() {
  const activesectionclass = "dropdownsection--active";
  // when time out ends and nav open is still false, close the sitenav
  // if (!navopen) {
  // Set height to 0 and remove classes
  const activeselection = document.querySelector("." + activesectionclass);
  if (activeselection) {
    activeselection.classList.remove(activesectionclass);
  }
  document.querySelector("body").classList.remove(navopenbodyclass);
  if (currentli) {
    currentli.classList.remove(overclass);
  }
  sitenavdropdown.style.height = 0;
  // }
} // sitenav__close
/* jshint ignore:end */

/*  ==========================================================================
	CARDGRID - cardgrid setup for homepage

  =   Card grid scroll: full script in vendor/cardgridscroll
	========================================================================== */

let animationSpeed = 300,
  desktopBreakpoint = 700,
  windowWidth = window.innerWidth,
  windowHeight = window.innerHeight;

function setWindowDimensions() {
  windowWidth = window.innerWidth;
  windowHeight = window.innerHeight;
}

// const cardGridDesktop = document.querySelector(".cardgrid--desktop");
const cardGridWrapper = document.querySelector(".stackmedia");
let CardGridInstance = false;

function cardGridShow() {
  setTimeout(function () {
    // cardGridDesktop.classList.remove("cardgrid--loading");

    setTimeout(function () {
      CardGridInstance.bindEvents();
      CardGridInstance.tick();
    }, animationSpeed * 2);
  }, animationSpeed);
}

let cardGridIsOn = false;

function cardGridInit() {
  //Setting up mouse inactivity message on the homepage
  let timeoutInMiliseconds = 8000;
  let timeoutId;

  function startTimer() {
    // window.setTimeout returns an Id that can be used to start and stop a timer
    timeoutId = window.setTimeout(whenInactive, timeoutInMiliseconds);
  }
  function resetTimer() {
    window.clearTimeout(timeoutId);
    startTimer();
    // document.querySelector(".cardgrid__notice").classList.remove("show");
  }

  function whenInactive() {
    // Show messeage on the homepage
    // document.querySelector(".cardgrid__notice").classList.add("show");
  }

  function setupTimers() {
    document.addEventListener("mousemove", resetTimer, false);
    document.addEventListener("mousedown", resetTimer, false);
    document.addEventListener("keypress", resetTimer, false);
    document.addEventListener("touchmove", resetTimer, false);

    startTimer();
  }
  setupTimers();

  // Checking for window resize
  window.addEventListener("resize", function () {
    setWindowDimensions();

    CardGridInstance = new CardGridMoves({
      el: cardGridWrapper,
      ease: 0.02
    });
  });

  // On page load if is desktop load cardgrid
  if (cardGridWrapper) {
    CardGridInstance = new CardGridMoves({
      el: cardGridWrapper,
      ease: 0.02
    });

    cardGridShow();
  }
}
